const NavbarData = [
  {
    name: "Home",
    url: "/",
    id: "",
  },
  {
    name: "About us",
    url: "/about",
    id: "",
    subMenu: [
      {
        name: "who are we?",
        url: "/about",
        id: "#special",
      },
      {
        name: "Our Mission",
        url: "/about",
        id: "#mission",
      },
      {
        name: "Our Vision",
        url: "/about",
        id: "#vision",
      },
      {
        name: "Our Team",
        url: "/about",
        id: "#team",
      },
    ],
  },
  {
    name: "Our business",
    url: "/business",
    id: "",
    subMenu: [
      {
        name: "Process Engineering",
        url: "/business",
        id: "#process",
      },
      {
        name: "Piping Engineering ",
        url: "/business",
        id: "#piping",
      },
      {
        name: "Mechanical Engineering",
        url: "/business",
        id: "#mechanical",
      },
      {
        name: "Civil & Structural Engineering",
        url: "/business",
        id: "#civil",
      },
      {
        name: "Electrical Engineering",
        url: "/business",
        id: "#electrical",
      },
      {
        name: "Flow Assurance Service",
        url: "/business",
        id: "#flow",
      },
      {
        name: "Instrumentation Engineering",
        url: "/business",
        id: "#instrumentation",
      },
      {
        name: "Other Services",
        url: "/business",
        id: "#other",
      },
    ],
  },
  {
    name: "Contact Us",
    url: "/contact",
    id: "",
    subMenu: [
      {
        name: "Email",
        url: "/contact",
        id: "#email",
      },
      {
        name: "Phone / Whatsapp",
        url: "/contact",
        id: "#phone",
      },
      {
        name: "Contact Form",
        url: "/contact",
        id: "#form",
      },
    ],
  },
];

export default NavbarData;
